import { useMemo } from 'react'
import { useParams } from 'wouter'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'

import { Suspense } from '@/components/ui/Suspense'
import { GoodieForm } from '@/features/goodies'
import { DialogHeader } from '@/layouts/Dialog'
import { useOrganization } from '@/features/organization'
import { Trans } from '@lingui/react/macro'

function Description({ goodie }: { goodie: GraphQL.GoodieFragmentFragment }) {
  const { appUrl } = useOrganization()
  const goodieName = goodie.name

  return (
    <span>
      <span>
        <Trans comment="Description for the Goodie Dialog">
          Show or Edit of a Goodie with the Name &quot;{goodieName}&quot;.
        </Trans>
      </span>
      <br />
      <a
        className="text-info-500 underline"
        href={`${appUrl}/goodies/${goodie.token}`}
        target="_blank"
        rel="noreferrer"
      >
        <Trans>Open in your Guest-App</Trans>
      </a>
    </span>
  )
}

function Goodie({ token }: { token: string }) {
  const { data } = useSuspenseQuery(AdminAPI.goodie.GET_BY_TOKEN, {
    variables: { token, withGallery: true, withTranslations: true },
    fetchPolicy: 'cache-and-network'
  })

  const goodie = useMemo(
    () => getFragment(SharedAPI.goodie.GOODIE_FRAGMENT, data?.getGoodieByToken),
    [data]
  )

  return (
    <div className="flex flex-col p-5">
      <DialogHeader
        description={<Description goodie={goodie} />}
        title={goodie.name}
      />
      <GoodieForm id={goodie.id} />
    </div>
  )
}

export default function GoodieSuspense() {
  const params = useParams() as { token: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <Goodie token={params.token} />
    </Suspense>
  )
}
